export const POPULAR_HOTELS = [{
  type: "cities",
  label: "Cairo",
  value: "113116",
  country: "EG",
  subLabel: "Egypt",
},{
  type: "cities",
  label: "Dubai",
  value: "115936",
  country: "AE",
  subLabel: "United Arab Emirates",
},{
  type: "hotels",
  label: "Sheraton Cairo Hotel & Casino",
  value: "1000073",
  country: "EG",
  subLabel: "Cairo, Egypt",
},]